<template>
    <div>
    <!-- HEADER TITULO -->
        <div class="titulo-contenido">
            <h1>
                <span class="negrita">CONÓCENOS</span>
            </h1>
        </div>
        <!-- OPCIONES INTERNAS(TABS) -->
        <div class="menuOpciones_tabs d-flex justify-content-center" style="background: white;">
            <ul class="d-flex horizontal-scroll-contenedor">
                <li class="opc">
                   <router-link :to="{name: 'secretaria-de-finanzas'}"  id="opcSecretaria"> Secretaría de Finanzas</router-link>
                </li>
                <li class="opc mr-3">
                    <router-link :to="{name: 'manuales-administrativos'}" id="opcManuales">Manuales Administrativos</router-link>
                </li>
                <li class="opc mr-3">
                    <router-link :to="{name: 'integridadPublica'}" id="opcManuales">Integridad Pública</router-link>
                </li>
            </ul>
        </div>

        <div :class="clase()">
            <router-view></router-view>
        </div>

    </div>
</template>
<script>

export default {
    data: function() {
        return{

        }
    },
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{


    },
    methods:{
        clase(){
            if( window.location.pathname == '/conocenos/manuales-administrativos/tramites-servicios'){
                // console.log('tramites');
                return "";
            }else{
                // console.log('otros'); // contenedor_padre era lo q iba a ahi
                return 'container'
            }
        }
    }
}
</script>
<style scoped>

</style>
